/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const resetPasswordRequestSchema = z.object({
  token: z.coerce.string(),
  newPassword: z.coerce.string().min(8).max(200),
  newPasswordRepeat: z.coerce.string().min(8).max(200),
});
